import CopyLogButton from './CopyLogButton';

export default CopyLogButton;
